import Http from './base-http'

class applyAction extends Http {
  applyAction(data) {
    return this.client
      .put(`${data.id}`, data)
  }
}

const applyActions = new applyAction({
  modelUrlPrefix : 'WorkScheduleRequestUser'
})

export default applyActions
